export default {
  toggleOrderDetailsModal (state, value) {
    state.orderDetailsModal = value
  },
  loadOrders (state, payload) {
    state.totalItems = payload.totalItens
    state.currentPage = payload.paginaAtual
    state.totalPages = payload.totalPaginas
    state.itemsPerPage = payload.itensPorPagina
    state.registeredOrders = payload.list
    state.paginaInicial = payload.paginaInicial
    state.paginaFinal = payload.paginaFinal
  },
  loadOrderDetails (state, payload) {
    state.selectedOrder = payload
  },
  updateRegisteredOrders (state, payload) {
    state.registeredOrders = state.registeredOrders.filter(elm => elm.id !== state.selectedOrder.id)
  },
  updateOrderReason (state, value) {
    state.selectedOrder.idReason = value
  },
  toggleLoadingOrderActions (state, value) {
    state.loadingOrderActions = value
  },
  resetPedido (state) {
    state.registeredOrders = []
  },
  toggleLoadingFeatured (state, value) {
    state.loadingFeatured = value
  },
  updateSearchOrders (state, value) {
    state.searchOrders = value
  },
  nextPage (state) {
    state.currentPage ++
  },
  prevPage (state) {
    state.currentPage --
  },
  changeItemsPerPage (state, value) {
    state.itemsPerPage = value
  },
  loadOrderPrint (state, payload) {
    state.orderPdf = payload
    console.log(payload)
    const link = document.createElement('a')
    link.href = process.url + '../../' + payload
    link.target = '_blank'
    link.setAttribute('download', 'pedido.pdf')
    document.body.appendChild(link)
    link.click()
  }
}



// WEBPACK FOOTER //
// ./src/store/pedido/mutations.js